
import { Component, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { CustomizerComponentHeaderComponent, CustomizerListComponent } from '@app/customizer/components';
import { MiscModel } from '@models/misc-model';
import { ConfigurationService } from '@services/configuration.service';
import { ComponentVariantModel } from '@models/component-variant';
import { ConfigurationModel } from '@models/configuration';
import { CustomizerMenuPartModel } from '@models/customizer-menu-part';
import { ModelGroupModel } from '@models/model-group';
import { ModelSizeModel } from '@models/model-size';
import { EventsService } from '@services/events.service';
import { DataApiService } from '../../../../_services/data-api.service';
import { SorterService } from '../../../../_services/sorter.service';
import { BaseCustomizerComponent } from './../../../../shared/base-customizer-component';

@Component({
    template: `
        <customizer-component-header [menu]="menu" (updateCollapsedOnComponent)="updateCollapsed($event)">
          @if (boxList?.length) {
            <customizer-list
              class="bordered"
              [isModelSize]="true"
              (selectedChange)="onSelect($event)"
              [items]="boxList"
              [name]="'Code'"
              [discontinued]="'Discontinued'"
              [selectedIndex]="selectedIndex"
              [editMode]="state === customizerStateEnum.EDITORDER"
              [variantOrModelIsNew]="variantOrModelIsNew"
              [(scrollPosition)]="menu.menuDetails.scrollPosition"
              [image]="getVoid"
            ></customizer-list>
          }
        </customizer-component-header>
        `,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
    CustomizerComponentHeaderComponent,
    CustomizerListComponent
]
})
export class ModelSizeComponent extends BaseCustomizerComponent {

	public boxList?: Array<ModelSizeModel> = [];
	public selectedIndex?: number = 0;

	public static override shouldBeVisible = (modelGroup: ModelGroupModel | undefined, menuComponents: CustomizerMenuPartModel, variants: Array<ComponentVariantModel> | undefined, configurations: Array<ConfigurationModel>, demo: boolean, chosenCase?: MiscModel | null): boolean => {
		return true;
	}

	constructor(
		public override events: EventsService,
		private apiService: DataApiService,
		private sorter: SorterService,
		public override configurationService: ConfigurationService
	) {
		super(events, apiService, configurationService);
	}

	async initData() {
		this.events.showLoader(true);

		this.boxList = await this.fetchSizes();
		this.modelSize = this.boxList?.find(x => x.Uuid == this.modelSize?.Uuid);
		this.selectedIndex = this.boxList?.findIndex(x => x.Uuid == this.modelSize?.Uuid);

		this.events.showLoader(false);
	}

	onChanges(changes: SimpleChanges) {
		this.selectedIndex = this.boxList?.findIndex(x => x.Uuid == this.modelSize?.Uuid);
	}

	onSelect(item: number) {
		this.events.showLoader(true);
		this.updateSize(this.boxList?.[item]);
	}

	async fetchSizes(): Promise<Array<ModelSizeModel> | undefined> {
		let modelSizes: Array<ModelSizeModel> | undefined;

		const apidata = await this.apiService.getSizes(this.model.ProductLineUuid, this.modelGroup.modelGroupDataUuid, this.model.Uuid);

		apidata?.forEach(element => {

			element.DblWithAdditionalSizeInfo = this.DblWithAdditionalSizeInfo(element.Code)
		});

		modelSizes = apidata?.sort(this.sorter.sortBy(ModelSizeModel));

		return modelSizes;
	}

	/** Splits 42#17-A Or 42#17 split into ["42", "17"] or ["40", "17-A"] */
	DblWithAdditionalSizeInfo(sizeCode: string): string {
		if (!sizeCode) return "";

		const parts = sizeCode.split("#");
		if (parts.length > 2) {
			console.warn(`Invalid sizeCode '${sizeCode}'. Too many '#' characters.`);
			return "";
		}

		return parts.length > 1 ? parts[1] : "";
	}

	getVoid = () => {
		return '';
	}

}
